<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title"><em>Contents</em></h1>
<p class="toc-fm"><a href="#/005_Acknowledgements#fm-1"><em>Acknowledgments</em></a></p>
<p class="toc-fm"><a href="#/006_Introduction#fm-2">Introduction</a></p>
<p class="toc-chap"><span href="#/007_Chapter01#ch-1" title="Link target outside of Sample">1.<span class="pad">Worship as Our Paradigm for Mission</span></span></p>
<p class="toc-chap"><span href="#/008_Chapter02#ch-2" title="Link target outside of Sample">2.<span class="pad">Integrity Matters</span></span></p>
<p class="toc-chap"><span href="#/009_Chapter03#ch-3" title="Link target outside of Sample">3.<span class="pad">Keeping Perspective</span></span></p>
<p class="toc-chap"><span href="#/010_Chapter04#ch-4" title="Link target outside of Sample">4.<span class="pad">A Community of Friends</span></span></p>
<p class="toc-chap"><span href="#/011_Chapter05#ch-5" title="Link target outside of Sample">5.<span class="pad">Leadership in Community</span></span></p>
<p class="toc-chap"><span href="#/012_Chapter06#ch-6" title="Link target outside of Sample">6.<span class="pad">How Are Good Works Good?</span></span></p>
<p class="toc-bm"><span href="#/013_Appendix#bm-1" title="Link target outside of Sample">Appendix</span></p>
<p class="toc-fm"><span href="#/014_Afterword#bm-2" title="Link target outside of Sample"><em>Afterword</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004_Contents.vue?09566874